import { NAV_ITEMS } from '../lib/constants'

export default function MobileNav({ activeTab, setActiveTab, unreadInvites, unreadChats = 0 }) {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur border-t border-gray-200 flex sm:hidden">
      {NAV_ITEMS.slice(0, 6).map(item => (
        <button key={item.id} onClick={() => setActiveTab(item.id)}
          className={`flex-1 flex flex-col items-center py-3 text-xs font-semibold transition relative ${activeTab === item.id ? 'text-orange-600' : 'text-gray-500'}`}>
          <span className="text-xl">{item.icon}</span>
          <span className="mt-0.5">{item.label}</span>
          {item.id === 'invites' && unreadInvites > 0 && (
            <span className="absolute top-2 right-[20%] rounded-full bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center">{unreadInvites}</span>
          )}
          {item.id === 'chats' && unreadChats > 0 && (
            <span className="absolute top-2 right-[20%] rounded-full bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center">{unreadChats > 9 ? '9+' : unreadChats}</span>
          )}
          {activeTab === item.id && <span className="absolute top-0 inset-x-4 h-0.5 bg-orange-500 rounded-full" />}
        </button>
      ))}
    </nav>
  )
}
